import {createAsyncThunk} from "@reduxjs/toolkit";
import {ILogin, ILoginResponse} from "../../types/ILogin";
import {AuthService} from "../../service/auth/auth.service";

export const login = createAsyncThunk<null, ILogin>(
    'auth/login',
    async function (body, {rejectWithValue}) {
        try {
            const response = await AuthService.login(body)
            localStorage.setItem('access_token', response.data.access)
            localStorage.setItem('user_name', body.username)
            return null
        } catch (e) {
            return rejectWithValue(e)
        }
    }
)

export const refresh = createAsyncThunk<ILoginResponse>(
    'auth/refresh',
    async function (_, {rejectWithValue}) {
        try {
            const response = await AuthService.refresh();
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            return response.data;
        } catch (e) {
            return rejectWithValue(e);
        }
    }
)

